export default __webpack_public_path__ + "static/media/Vue.js-Logo.4921ee76.svg";